import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Silent, Union, Unknown } from "@/__main__/data-model.mjs";

const jobModel = {
  id: Number,
  title: String,
  location: {
    name: String,
  },

  // Not sure if this is correct, as I cannot find it in their API docs. Seems to
  // contain full time or part time information, but I don't see it in responses either?
  type: Silent(Union([String, "Full Time"])),

  absolute_url: String,
  data_compliance: [
    { type: String, requires_consent: Boolean, retention_period: Unknown },
  ],
  internal_job_id: Number,
  metadata: [Unknown],
  requisition_id: String,
  updated_at: Date,
} satisfies ModelDefinition;

export const JobsModel = createModel({
  jobs: [jobModel],
  meta: {
    total: Number,
  },
}).transform([jobModel], (data) => data.jobs);

const departmentModel = {
  id: Number,
  name: String,
  parent_id: Union([Number, null] as [NumberConstructor, null]),
  child_ids: [Number],
  jobs: [jobModel],
} satisfies ModelDefinition;

export const DepartmentsModel = createModel({
  departments: [departmentModel],
}).transform([departmentModel], (data) => data.departments);

export type GreenhouseJobs = FromModel<typeof JobsModel>;
export type GreenhouseDepartments = FromModel<typeof DepartmentsModel>;
